export default class VerifyResponse {
    constructor(
        public success: boolean,
        public errorMessages: string[],
    ) { }
}